/*
 Initial state and properties
 */
 export const initialState = {
    mode:"POST",
    positionIdSelected:0,
    defaultDataPosition:null
 }
 /*
  Action types
  */
 export const SET_MODE = 'SET_MODE'
 export const SET_POSITION_ID = 'SET_POSITION_ID'
 export const SET_DEFAULT_DATA = 'SET_DEFAULT_DATA'
 /*
  Arrow function for change state
  */
 export const setMode = (payload) => ({
   type: SET_MODE,
   payload,
 });
 export const setPositionId = (payload) => ({
  type: SET_POSITION_ID,
  payload,
})
export const setDefaultData = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
})
 /*
  Reducer to describe how the state changed
  */
 export default function Reducer(state = initialState, { type, payload }) {
   switch (type) {
     case SET_MODE:
       return {
         ...state,
         mode: payload,
       }
       case SET_POSITION_ID:
        return {
          ...state,
        positionIdSelected: payload,
        }
        case SET_DEFAULT_DATA:
          return {
            ...state,
            defaultDataPosition: payload,
          }
     default:
       return state
   }
 }
 